import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/subscriptions/cart']['POST'];
type Input = THIS_API['body'];
type Output = THIS_API['response'];

const createStripeSubscriptions = async (data: Input): Promise<Output> =>
  noodleApiClient.post('/subscriptions/cart', data);

export default createStripeSubscriptions;
